import { useTranslation } from 'react-i18next';
import './Contact.css';

export function Contact() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="section">
      <div className="container container-narrow">
        <div className="section-header">
          <span className="eyebrow">{t('contact.eyebrow')}</span>
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.subtitle')}</p>
        </div>
        <div className="contact-grid">
          <a className="contact-card" href={`mailto:${t('contact.general.email')}`}>
            <span className="contact-card__label">{t('contact.general.label')}</span>
            <span className="contact-card__email">{t('contact.general.email')}</span>
          </a>
          <a className="contact-card" href={`mailto:${t('contact.support.email')}`}>
            <span className="contact-card__label">{t('contact.support.label')}</span>
            <span className="contact-card__email">{t('contact.support.email')}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
